import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import ImageRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Image/Renderer/ImageRenderer'

const ImageForm = lazyLoad(() => import('./Form/ImageForm'))

const imagePlugin = settings =>
    createPlugin({
        Renderer: ImageRenderer,
        Controls: ImageForm,
        ...settings,
    })

const image = imagePlugin()
export default image

export { imagePlugin, ImageRenderer }
